import { useBrandPageCartStateContext } from "../../contexts/BrandPageCartStateContext";

export const useIsQualifiedForCollectionDisplayPromo = (): boolean => {
  const { brandCartViewState } = useBrandPageCartStateContext();
  return brandCartViewState.isQualifiedForCollectionDisplayPromo;
};
